import { RiMegaphoneLine } from 'react-icons/ri';

const CampaignIcon = () => <RiMegaphoneLine size={20} />;

export default CampaignIcon;
